import { RunTSX } from '~components/mdx/RunTSX';
import React from 'react';
export default {
  RunTSX,
  React
};